export const corFM = '#2e62b8';

export const corGF = '#3da4bc';

export const link = '#7cdbf1';

export const backgroundColorLogin = '#f6f7f9';
